import styles from 'components/Player/AudioPlayerWrapper/PlayQueue/PlayQueue.module.scss';
import { useTranslation } from 'hooks/useTranslation';
import { PlayQueueCard } from 'components/Player/AudioPlayerWrapper/PlayQueue/PlayQueueCard';
import { useFeatureFlag } from 'contexts/FeatureFlagContext/FeatureFlagContext';
import { QueueItem } from '../../../../contexts/PlayerStateContext/QueueItem';

type Props = {
  items: QueueItem[];
  selectedItemKeys: string[];
  setItemSelection: (selected: boolean, itemKey: string) => void;
};

const NextInQueueList = ({
  items,
  selectedItemKeys,
  setItemSelection,
}: Props) => {
  const t = useTranslation();
  const { playQueue2024 } = useFeatureFlag();

  return (
    <div>
      <h3 className={styles.subTitle}>{t('nextInQueue')}</h3>
      {items &&
        items.map((item) => {
          return (
            <div key={item.key} className={styles.cardContainer}>
              <PlayQueueCard
                item={item}
                isActive={false}
                isSortable={true}
                isSimpleCard={playQueue2024}
                isCheckboxSelected={selectedItemKeys.includes(item.key)}
                setCheckboxSelected={(selected) => {
                  setItemSelection(selected, item.key);
                }}
              />
            </div>
          );
        })}
    </div>
  );
};

export default NextInQueueList;
